import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://localhost:7008/api";

const api = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

export function getApiOrigin(): string {
  const base = api.defaults.baseURL ?? "";
  return base.replace(/\/?api\/?$/i, "").replace(/\/$/, "");
}

api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("authUser");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
